export default __webpack_public_path__ + "static/media/dollar-sign.d5a60a49.svg";